import { Component, inject, output, signal } from '@angular/core';

import { FilteringService } from '../../../services/filtering';
import { ListingsService } from '../../../services/listings/listings';
import { SaveService } from '../../../services/save/save';
import { StateService } from '../../../services/state/state';
import { Filters } from '../../filters/filters';
import { SavedFilters } from '../../filters/saved-filters/saved-filters';
import { SearchInput } from '../../search-input/search-input';
import { Toggle } from '../../toggle/toggle';

@Component({
  imports: [SearchInput, Toggle, SavedFilters, Filters],
  selector: 'app-toolbar-desktop',
  styleUrl: './desktop.css',
  templateUrl: './desktop.html',
})
export class Desktop {
  protected readonly filteringService = inject(FilteringService);
  protected readonly listingsService = inject(ListingsService);
  protected readonly saveService = inject(SaveService);
  protected readonly stateService = inject(StateService);

  public readonly modelGalleryClicked = output();

  protected readonly filtersOpen = signal(false);
  protected readonly saveSearchOpen = signal(false);

  private _dreamHomesTimeout: ReturnType<typeof setTimeout> | undefined = undefined;
  private _saveSearchTimeout: ReturnType<typeof setTimeout> | undefined = undefined;

  protected async toggleDreamHomes(): Promise<void> {
    if (this._dreamHomesTimeout) {
      return;
    }

    const _currentState = this.filteringService.dreamHomes();

    if (!this.stateService.userToken()) {
      this.stateService.handleAuthRequest();

      this._dreamHomesTimeout = setTimeout(() => {
        this.stateService.authPromiseRejecter?.();
        clearTimeout(this._dreamHomesTimeout);
        this._dreamHomesTimeout = undefined;
        return;
      }, 30000);

      // Wait an additional second to ensure the token is set.
      await this.stateService.authPromise();
    }

    if (!this.stateService.userToken()) {
      return;
    }

    clearTimeout(this._dreamHomesTimeout);
    this._dreamHomesTimeout = undefined;

    void this.filteringService.resetFilters().then(() => {
      if (!_currentState) {
        setTimeout(() => {
          this.filteringService.ids.set(
            this.filteringService
              .userSavedListingIds()
              .map((listing) => listing.itemId)
              .filter((id) => id !== ''),
          );
          this.filteringService.dreamHomes.set(true);
        }, 300);

        return;
      } else {
        this.filteringService.dreamHomes.set(false);
        this.filteringService.ids.set([]);
      }
    });
  }

  protected toggleFilters(): void {
    this.filtersOpen.update((v) => !v);
  }

  protected async toggleSaveSearch(): Promise<void> {
    if (this._saveSearchTimeout) {
      return;
    }

    if (!this.stateService.userToken()) {
      this.stateService.handleAuthRequest();

      this._saveSearchTimeout = setTimeout(() => {
        this.stateService.authPromiseRejecter?.();
        clearTimeout(this._saveSearchTimeout);
        this._saveSearchTimeout = undefined;
        return;
      }, 30000);
      // Wait an additional second to ensure the token is set.
      await this.stateService.authPromise();
    }

    if (!this.stateService.userToken()) {
      return;
    }

    clearTimeout(this._saveSearchTimeout);
    this._saveSearchTimeout = undefined;

    this.saveSearchOpen.update((v) => !v);
  }
}
